import React, { useState, useEffect, useContext } from "react";
import api from "../api/axios";
import "../styles/App.scss?v=1.1.9";
import "./Scss/LoginStyles.scss?v=1.1.3";
import {
  Grid,
  OutlinedInput,
  FormControl,
  InputAdornment,
  IconButton,
  Box,
  InputLabel,
  CircularProgress,
  Stack,
  TextField,
  Fade,
  Alert,
  Button,
} from "@mui/material";
import {
  Visibility,
  VisibilityOff,
  Email,
  LockReset,
} from "@mui/icons-material";
import { useNavigate, useLocation } from "react-router-dom";
import fidelitis2 from "../assets/fidelitis2.png";
import Axios from "axios";
import ChangePassword from "../Components/ChangePassword";
import { CustomButtonPlusIcon } from "../Components/Common/Design/CustomButtonPlusIcon";
import { UserContext } from "../Components/Context/Context";

const Swal = require("sweetalert2");

const LoginError = ({ visible }) => {
  if (!visible) return null;
  return (
    <Alert
      severity="error"
      style={{ marginTop: "10px" }}
      sx={{
        alignItems: "center",
        "& .MuiAlert-icon": { display: "flex", alignItems: "center" },
        textAlign: "left",
      }}>
      Datos incorrectos. Por favor, verifica tu información e intenta de nuevo.
    </Alert>
  );
};

function Login() {
  const [actualYear] = useState(new Date().getFullYear());
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loginError, setLoginError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [openDialog, setOpenDialog] = useState(false);

  const { fetchUserData, isLoggedIn, isLoading } = useContext(UserContext);

  const navigate = useNavigate();
  const reactLocation = useLocation();

  const [hover, setHover] = useState(false);
  const [bgLoaded, setBgLoaded] = useState(false);

  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = (event) => event.preventDefault();

  const handleLogin = async () => {
    console.log("Iniciando sesión");

    try {
      setIsSubmitting(true);
      setLoginError(false);

      await Swal.fire({
        title: "Iniciando sesión...",
        html: "Por favor espera",
        timer: 1000,
        timerProgressBar: true,
        allowOutsideClick: false,
        showCancelButton: false,
        showConfirmButton: false,
        // didOpen: () => {
        //   Swal.showLoading();
        // },
      }).finally(() => {
        document.body.style.overflow = "";
      });

      const response = await api.post("/login", { email, password });

      console.log(response);

      if (response.data.message === "Login Correcto") {
        // Ya se envió cookie HttpOnly desde backend
        await fetchUserData(); // Trae los datos del usuario usando la cookie
      } else {
        setLoginError(true);
      }
    } catch (error) {
      console.error("Error en login:", error);
      setLoginError(true);
    } finally {
      setIsSubmitting(false);
      Swal.close();
    }
  };

  useEffect(() => {
    if (!isLoading && isLoggedIn) {
      const from = reactLocation.state?.from?.pathname ?? "/panel";
      navigate(from, { replace: true });
    }
  }, [isLoading, isLoggedIn, navigate, reactLocation]);

  return (
    <div>
      <Fade in={bgLoaded} timeout={1000}>
        <img
          src={fidelitis2}
          alt="Fondo Login"
          className="fondoLogin"
          style={{ display: bgLoaded ? "block" : "none" }}
          onLoad={() => setBgLoaded(true)}
        />
      </Fade>
      <Fade timeout={600} in>
        <Box sx={{ width: "100%", position: "relative", height: "100vh" }}>
          <Grid
            container
            item
            xs={10}
            md={6}
            lg={5}
            sx={{
              textAlign: "center",
              padding: "50 20px 20px 20px",
              // boxShadow: "0px 0px 15px 0px #1800b926",
              boxShadow: "0px 0px 250px -40px #1800b926",
              margin: "auto !important",
              position: "absolute",
              left: "0",
              right: "0",
              bottom: "0",
              top: "0",
              height: "640px",
              width: "540px",
              background: "#ffffff69",
              borderRadius: "4px",
            }}>
            {/* Logo */}
            <Grid
              item
              xs={12}
              md={12}
              sx={{
                justifyContent: "center",
                position: "relative",
                display: "flex",
                alignItems: "center",
              }}>
              <div className="logo-name">CRM </div>
              <div className="generalLogo legalSubTitle">Legal</div>
              <div className="generalLogo byFide">by Fidelitis</div>
            </Grid>

            {/* Formulario */}
            <Grid item xs={8} md={8} sx={{ margin: "auto" }}>
              <Box
                component="form"
                sx={{ textAlign: "center" }}
                noValidate
                autoComplete="off">
                {/* Email */}
                <FormControl sx={{ width: "100%", marginBottom: "10px" }}>
                  <TextField
                    color={loginError ? "error" : "primary"}
                    size="small"
                    name="emailLogin"
                    error={loginError}
                    label="Email"
                    id="emailLogin"
                    autoFocus={loginError}
                    value={email}
                    fullWidth
                    onChange={(e) => setEmail(e.target.value)}
                    sx={{
                      paddingRight: "5px",
                      "& .MuiInputBase-input": { padding: "8px" },
                    }}
                    InputProps={{
                      endAdornment: (
                        <IconButton
                          aria-label="email"
                          sx={{ width: "45px" }}
                          edge="end">
                          <Email sx={{ width: "24px", height: "24px" }} />
                        </IconButton>
                      ),
                    }}
                  />
                </FormControl>

                {/* Password */}
                <FormControl sx={{ width: "100%", marginBottom: "10px" }}>
                  <TextField
                    error={loginError}
                    size="small"
                    type={showPassword ? "text" : "password"}
                    name="password"
                    label="Password"
                    id="password"
                    value={password}
                    fullWidth
                    onChange={(e) => setPassword(e.target.value)}
                    sx={{
                      paddingRight: "5px",
                      "& .MuiInputBase-input": { padding: "8px" },
                    }}
                    InputProps={{
                      endAdornment: (
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          sx={{ width: "45px" }}
                          edge="end">
                          {showPassword ? (
                            <Visibility
                              sx={{ width: "24px", height: "24px" }}
                            />
                          ) : (
                            <VisibilityOff
                              sx={{ width: "24px", height: "24px" }}
                            />
                          )}
                        </IconButton>
                      ),
                    }}
                  />
                </FormControl>

                {/* Botón login */}
                <Button
                  color="primary"
                  variant="contained"
                  fullWidth
                  // className="loginButtonStyles"
                  onClick={handleLogin}
                  disabled={isSubmitting}
                  sx={isSubmitting ? { opacity: 0.7 } : {}}>
                  {isSubmitting ? (
                    <CircularProgress color="inherit" size={16} />
                  ) : (
                    "ENTRAR"
                  )}
                </Button>
                {/* Link de recuperación */}
              </Box>
              <div style={{ textAlign: "center", marginTop: "20px" }}>
                {/* 🔒  */}
                <CustomButtonPlusIcon
                  color="info"
                  position="start"
                  size="small"
                  variant={"outlined"}
                  icon={LockReset}
                  handleFunction={() => setOpenDialog(true)}
                  text={"Cambiar contraseña"}
                />

                <div
                  style={{
                    marginTop: "8px",
                    fontSize: "12.5px",
                    color: "#888",
                    fontWeight: 400,
                    letterSpacing: "0.3px",
                  }}>
                  CRM Legal by Fidelitis © {actualYear}
                </div>
              </div>

              {/* Error */}
              <ChangePassword
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                view={"login"}
              />
              <LoginError visible={loginError} />
            </Grid>
          </Grid>
        </Box>
      </Fade>
    </div>
  );
}

export default Login;
